import { useMemo } from 'react';

import IB_Preset, { Custom_Preset } from '@bo-ibSheet/common';

const useDashboardGridOptions = () => {
  const gridOptions = useMemo(
    () => ({
      LeftCols: [{ ...Custom_Preset.RowIndex, Cursor: 'pointer' }],
      Cols: [
        {
          Header: '제목',
          Type: 'Text',
          Name: 'title',
          Width: 457,
          MinWidth: 457,
          Cursor: 'pointer',
          CanEdit: 0,
          CanSort: 0,
        },
        {
          ...IB_Preset.YMD12HMS,
          Header: '등록일시',
          Name: 'fromDateTime',
          MaxWidth: 132,
          Cursor: 'pointer',
          CanEdit: 0,
          CanSort: 0,
        },
      ],
    }),
    []
  );

  return { gridOptions };
};

export { useDashboardGridOptions };
